import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPaddingV: var(--sp5x);
	--headerPaddingH: var(--sp9x);

	//! Bookmark icon circle size
	--headerBookmarkActiveIconSize: var(--sp1-5x);

	//! Mobile Right Cont
	--burgerIconMarginLeft: var(--sp3x);

	display: flex;
	align-items: center;
	justify-content: space-between;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	padding: var(--headerPaddingV) var(--headerPaddingH);
	transform: translateY(-200%);
	z-index: 99;

	& + main {
		min-height: 100vh;
		${({ mainMinHeight }) => (mainMinHeight ? `min-height: ${mainMinHeight}px` : '')}
	}

	&:not(.disable-header-margin) {
		border-bottom: 1px solid var(--borderColor);

		& + main {
			margin-top: ${({ topPosition }) => `${topPosition}px`};
			margin-top: var(--headerFixHeight);
			min-height: calc(100dvh - ${({ topPosition }) => `${topPosition}px`});
			min-height: calc(100dvh - var(--headerFixHeight));

			${({ mainMinHeight, topPosition }) => (mainMinHeight ? `min-height: ${mainMinHeight - topPosition}px` : '')}
		}

		& + main.Map > .map-container {
            height: calc(100dvh - ${({ topPosition }) => `${topPosition}px`});
			height: calc(100dvh - var(--headerFixHeight));
            
			${({ mainMinHeight, topPosition }) => (mainMinHeight ? `height: ${mainMinHeight - topPosition}px` : '')}
		}
	}

	&.transparent-header {
		button,
		a {
			--color: var(--secondaryColor1);
			--borderColor: var(--secondaryColor1);
		}
	}

	.link-item {
		.giz-bookmarks {
			position: relative;

			&:after {
				content: '';
				position: absolute;
				top: 0;
				right: 0;
				width: var(--headerBookmarkActiveIconSize);
				height: var(--headerBookmarkActiveIconSize);
				background: var(--primaryColor2);
				border: 1px solid var(--primaryColor3);
				border-radius: 50%;
				box-sizing: border-box;
				transform: translate3d(50%, -50%, 0);
				opacity: 0;
				transition: var(--trTime);
			}

			&.active {
				&:after {
					opacity: 1;
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--headerPaddingV: var(--sp4x);
		--headerPaddingH: var(--sp7x);
		--headerBookmarkActiveIconSize: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--headerPaddingV: var(--sp3x);
		--headerPaddingH: var(--sp5x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--headerPaddingV: var(--sp3x);
		--headerPaddingH: var(--sp4x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--headerPaddingV: var(--sp3x);
		--headerPaddingH: var(--sp4x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--headerPaddingV: var(--sp3x);
		--headerPaddingH: var(--sp4x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--headerPaddingV: var(--sp3x);
		--headerPaddingH: var(--sp4x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--headerPaddingV: var(--sp2x);
		--headerPaddingH: var(--sp3x);
		--headerBookmarkActiveIconSize: var(--sp1x);
	}

	//! Mobile Right Cont Styles
	@media (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		.mobile-right-cont {
			display: flex;
			align-items: center;

			.burger-icon {
				margin-left: var(--burgerIconMarginLeft);
			}
		}
	}
`;

export default HeaderStyle;
